'use client';

import { ModalBase as CommonModalBase, type ModalBaseProps } from '@monorepo/common';

function ModalBase(props: ModalBaseProps) {
  return <CommonModalBase {...props} />;
}

export default ModalBase;
